import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import FirstReport from "./FirstReport";
import SecondReport from "./SecondReport";
import ThirdReport from "./ThirdReport";
import { CONDITIONALROUTES, STEPS } from "app/components/ConditionalEnums";
import { CostData } from "atoms/CostToCarbonData";

const CurrentReports = ({ isHotSpotAvailable,
  cppData,
  setCppData,
  totalJobs,
  setTotalJobs,
  setSingleJobTime,
  singleJobTime,
  machineImage,
  setMachineimage,
  psImage,
  setPsImage,
  setcppSum,
  cppSum,
  setHotSpotArray,
  hotspotArray,
  scenarioTotalJobs,
  scenarioJobsLoading,

 }) => {
  const [step, setStep] = useState("first");
  const [costData, setCostData] = useState()
  const history = useHistory();
  const updatedCostData = useRecoilValue(CostData)

  useEffect(() => {
    if (history.location.pathname === CONDITIONALROUTES.GENERATEDREPORT) {
      setCostData(updatedCostData);
    }
    else {
      setCostData(JSON.parse(localStorage.getItem("CostData")));

    }
  }, [])


  return (

    <>

      {
        costData !== undefined
        &&
        <>

          <div className="reports-section">
            {step === STEPS.ONE && (
              <FirstReport
                staticData={costData}
                ScenarioState={() => setStep(STEPS.TWO)}
                cppData={cppData}
                setCppData={setCppData}
                totalJobs={totalJobs}
                setTotalJobs={setTotalJobs}
                setSingleJobTime={setSingleJobTime}
                singleJobTime={singleJobTime}
                machineImage={machineImage}
                setMachineimage={setMachineimage}
                psImage={psImage}
                setPsImage={setPsImage}
                setcppSum={setcppSum}
                cppSum={cppSum}
                setHotSpotArray={setHotSpotArray}
                hotspotArray={hotspotArray}
                isWorkingPerJobEditable={true}
              />
            )}
            {step === STEPS.TWO && (
              <SecondReport
              setMachineimage={setMachineimage}

                isHotSpotAvailable={isHotSpotAvailable}
                staticData={costData}
                isWorkingPerJobEditable={true}
                PreviousScenarioState={() => setStep(STEPS.ONE)}
                ScenarioState={() => setStep(STEPS.THREE)}
              />
            )}
            {step === STEPS.THREE && (
              <ThirdReport
                PreviousScenarioState={() => setStep(STEPS.TWO)}
                staticData={costData}
                scenarioTotalJobs={scenarioTotalJobs}
                scenarioJobsLoading={scenarioJobsLoading}
              />
            )}
          </div>

        </>

      }
    </>

  );
};

export default CurrentReports;
